import { Component, OnInit } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

// MODELOS
import {
  CompanyModelResponse, CompanyListResponse, CompanyModel, SapConnectionModel, SapConnResponse

} from './../../../models/index'

// RUTAS
// COMPONENTES
// SERVICIOS
import { AlertService, ConfigParamsService } from './../../../services/index'



@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.css']
})
export class CompanyComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  public createCompanyForm: FormGroup;
  public updateCompanyForm: FormGroup;

  companyList: Array<CompanyModel>; // obj almacena la lista de companias activas
  companyInEdition: CompanyModel; // obj almacena la compañia seleccionada
  sapConnList: Array<SapConnectionModel>; // obj que almacena conexiones sap

  constructor(private fb: FormBuilder,
    private configParamsService: ConfigParamsService,
    private alertService: AlertService
  ) { }

  errorMessage: string; // variable para el mensaje en caso de error

  ngOnInit() {
    this.ngOnLoad();
  }

  ngOnLoad() {
    this.createCompanyForm = this.fb.group({
      dbCode: ['', Validators.required],
      companyName: ['', Validators.required],
      sapConnectionId: ['', Validators.required],
      active: ['', Validators.required],
      companyReportName: ['', Validators.required],
      businessPartnerReportName: ['', Validators.required],
      supplierReportName: ['', Validators.required],
      emailTo: ['', Validators.required],
      emailCc: [''],
      InternalEmailReport: ['']
    });

    this.updateCompanyForm = this.fb.group({      
      dbCode: ['', Validators.required],
      companySelected: ['', Validators.required],
      companyName: ['', Validators.required],
      sapConnectionId: ['', Validators.required],
      active: ['', Validators.required],
      companyReportName: ['', Validators.required],
      businessPartnerReportName: ['', Validators.required],
      supplierReportName: ['', Validators.required],
      emailTo: ['', Validators.required],
      emailCc: [''],
      InternalEmailReport: ['']
    });

    this.getCompaniesList();
  }

  get formCreateCompany() {
    return this.createCompanyForm.controls;
  }
  get formUpdateCompany() {
    return this.updateCompanyForm.controls;
  }

  getCompaniesList() {
    this.blockUI.start('Buscando compañías');
    console.log('Buscando compañías');
    this.configParamsService.getCompanyList()
      .subscribe((data: CompanyListResponse) => {
        console.log(data);
        console.log(data.result);
        if (data.result) {
          this.companyList = data.CompanyList;
          this.blockUI.stop();
          this.getSapConnList();
        } else {
          this.blockUI.stop(); // Stop blocking
          this.errorMessage = data.errorInfo.Message;
          this.alertService.infoAlert(`${data.errorInfo.Message}`);
        }
      }, (error: any) => {
        console.log(error);
        this.blockUI.stop(); // Stop blocking
        this.alertService.errorAlert(`${error}`);
      });
  }

  getSapConnList() {
    this.blockUI.start('Buscando conexiones');
    console.log('Buscando conexiones');
    this.configParamsService.getSapConnList()
      .subscribe((data: SapConnResponse) => {
        if (data.result) {
          this.sapConnList = data.SapConnList;
          this.blockUI.stop();
        } else {
          this.blockUI.stop(); // Stop blocking
          this.errorMessage = data.errorInfo.Message;
          this.alertService.infoAlert(`${data.errorInfo.Message}`);
        }
      }, (error: any) => {
        console.log(error);
        this.blockUI.stop(); // Stop blocking
        this.alertService.errorAlert(`${error}`);
      });
  }

  createCompany() {
    this.blockUI.start('Creando la compañía.');
    console.log('Creando la compañía');
    this.configParamsService.createCompany(this.createCompanyForm)
      .subscribe((data: CompanyModelResponse) => {
        console.log(data);
        console.log(data.result);
        if (data.result) {
          this.alertService.successAlert("Compañía creada correctamente");
          this.createCompanyForm.reset(); 
          this.getCompaniesList();         
          this.blockUI.stop();          
        } else {
          this.blockUI.stop(); // Stop blocking
          this.errorMessage = data.errorInfo.Message;
          this.alertService.infoAlert(`${data.errorInfo.Message}`);
        }
      }, (error: any) => {
        console.log(error);
        this.blockUI.stop(); // Stop blocking
        this.alertService.errorAlert(`${error}`);
      });
  }

  updateCompany() {
    this.blockUI.start('Acutalizando la compañía');
    console.log('Acutalizando la compañía');
    this.configParamsService.updateCompany(this.companyInEdition, this.updateCompanyForm)
      .subscribe((data: CompanyModelResponse) => {
        console.log(data);
        console.log(data.result);
        if (data.result) {
          this.alertService.successAlert("Compañía actualizada correctamente");
          this.updateCompanyForm.reset(); 
          this.getCompaniesList();         
          this.blockUI.stop();          
        } else {
          this.blockUI.stop(); // Stop blocking
          this.errorMessage = data.errorInfo.Message;
          this.alertService.infoAlert(`${data.errorInfo.Message}`);
        }
      }, (error: any) => {
        console.log(error);
        this.blockUI.stop(); // Stop blocking
        this.alertService.errorAlert(`${error}`);
      });
  }

  companySelected($event) {
    console.log("CompanySelected");    
    this.companyInEdition = undefined;
    this.companyInEdition = this.companyList.find(company => company.Id == $event.target.value);
    if (this.companyInEdition) {
      this.PatchAlertData(this.companyInEdition);
    } else {
      this.updateCompanyForm.reset();
    }
  }

  PatchAlertData(company: CompanyModel){ 
    console.log("CompanyPatch");   
    this.updateCompanyForm.reset({
      dbCode: company.DbCode,
      companySelected: company.Id,
      companyName: company.CompanyName,
      sapConnectionId: company.SAPConnectionId,
      active: company.Active,
      companyReportName: company.ReportPathCompany,
      businessPartnerReportName: company.ReportPathBusinessPartner,
      supplierReportName : company.ReportPathSupplier,
      emailTo: company.EmailTo,
      emailCc: company.EmailCC,
      InternalEmailReport: company.InternalEmailReport
    })
  }
}
